export const logout = (keycloak, client) => {
  client.clearStore().then(() => {
    localStorage.clear()
    keycloak.logout({ redirectUri: window.location.origin })
  })
}
